export const KINDLY_SESSION_STORAGE_KEY = 'kindlySessionStatus';

export const KINDLY_SESSION_STATUS = {
    active: 'active',
    inactive: 'inactive',
};

export const VIEWS_WITHOUT_KINDLY = [
    'checkout',
    'searchresult',
    'product',
    'listing',
];
